import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ApiPageResponse, PageQuery } from '../types/api.types';
import { Rental } from '../types/rental.types';

@Injectable({ providedIn: 'root' })
export class RentalsService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.gatewayUrl}/rental/api/rentals`;

  list(query: PageQuery = {}): Observable<ApiPageResponse<Rental>> {
    return this.http.get<ApiPageResponse<Rental>>(this.base, {
      params: this.pageParams(query),
    });
  }

  get(id: number): Observable<Rental> {
    return this.http.get<Rental>(`${this.base}/${id}`);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }

  count(search?: string): Observable<number> {
    let params = new HttpParams();
    if (search?.trim()) params = params.set('search', search.trim());
    return this.http.get<number>(`${this.base}/count`, { params });
  }

  private pageParams(query: PageQuery): HttpParams {
    let params = new HttpParams()
      .set('pageable', 'true')
      .set('page', String(query.page ?? 1))
      .set('size', String(query.size ?? 10))
      .set('isDeleted', String(query.isDeleted ?? false));
    if (query.search?.trim()) params = params.set('search', query.search.trim());
    return params;
  }
}
